/** Maximum number of data rows permitted in a batch upload file (excluding the header row). */
export const PRE_TRADE_CHECKER_MAX_BATCH_ROWS = 200;

export interface PreTradeCheckerIndicator {
  indicator: string;
  value: number | string;
  unit: string | null;
}

export interface PreTradeCheckerResponse {
  name: string;
  indicators: PreTradeCheckerIndicator[];
}

export interface PreTradeCheckerParams {
  fundId: string;
  positionDate: string;
  isin: string;
}

export interface PreTradeCheckerBatchUploadParams {
  fundId: string;
  positionDate: string;
  file: File;
  onProgress: (progress: number) => void;
}

export type PreTradeCheckerCheckError = {
  reason?: string;
  value?: string;
  [key: string]: unknown;
};

export type PreTradeCheckerParsingError = {
  reason: string;
  value: string;
};

export type PreTradeCheckerSucceededResult = {
  indicators: PreTradeCheckerIndicator[];
  name: string;
};

/** Response body from `pre_trade_file_upload` (batch ISIN check results). */
export interface PreTradeCheckerBatchUploadResponse {
  succeeded: Record<string, PreTradeCheckerSucceededResult>;
  check_errors: Record<string, PreTradeCheckerCheckError | string>;
  parsing_errors: Record<string, PreTradeCheckerParsingError>;
  fund?: {
    fund_name: string;
    fund_type: string;
    fund_risk_type: string;
    fund_currency: string;
    fund_name_full: string;
  };
  date?: string;
  full_success: boolean;
}
